export const BUSINESS = {
  name: "Repair Point",
  tagline: "Your Trust, Our Expertise.",
  phone: "+1 (855) 454-4124",
  phoneHref: "tel:+18554544124",
  email: "support@repairpoint.in",
  emailHref: "mailto:support@repairpoint.in",
  address: "2118 Glenridge Ct, Marietta, GA 30062, USA",
  registeredAddress: "2118 Glenridge Ct, Marietta, GA 30062, USA",
  operationsAddress: "DG 03, 1st Floor, Gold City, Vashi, Navi Mumbai, 400705",
  hours: "Mon–Sat · 10:00 AM – 7:30 PM ET",
  yearsExperience: "10+",
  customersServed: "12,000+",
  established: "2014",
};

export const SERVICES = [
  {
    key: "virus-removal",
    icon: "Bug",
    title: "Virus & Malware Removal",
    short: "Deep-scan and full removal of viruses, ransomware, spyware and adware.",
    bullets: ["Full system scan", "Rootkit & ransomware cleanup", "Browser hijacker removal"],
    price: 99,
    priceLabel: "$99 flat",
  },
  {
    key: "pc-tuneup",
    icon: "Zap",
    title: "PC Slowdown & Tune-up",
    short: "Restore your Windows PC to like-new speed with a complete optimisation.",
    bullets: ["Startup & service audit", "Disk cleanup & SSD trim", "Driver & Windows updates"],
    price: 79,
    priceLabel: "$79 flat",
  },
  {
    key: "mac-cleanup",
    icon: "Monitor",
    title: "Mac OS Issues & Cleanup",
    short: "Fix beachballs, kernel panics, storage warnings and update failures on macOS.",
    bullets: ["macOS reinstall / repair", "Permissions & launchd cleanup", "Storage optimisation"],
    price: 89,
    priceLabel: "$89 flat",
  },
  {
    key: "data-recovery",
    icon: "HardDrive",
    title: "Data Recovery",
    short: "Recover photos, documents and projects from failing or formatted drives.",
    bullets: ["HDD, SSD & external drives", "Logical & light physical recovery", "No data, no fee"],
    price: 149,
    priceLabel: "from $149",
  },
  {
    key: "hardware",
    icon: "Cpu",
    title: "Hardware Diagnostics & Repair",
    short: "Screens, batteries, fans, keyboards, RAM & SSD upgrades for laptops and desktops.",
    bullets: ["Free written diagnostic", "OEM-grade parts available", "30-day workmanship warranty"],
    price: 49,
    priceLabel: "$49 diagnostic",
  },
  {
    key: "remote-support",
    icon: "Wifi",
    title: "Remote Support Session",
    short: "Quick fixes, software issues and Wi-Fi setup over a secure remote session.",
    bullets: ["Encrypted remote access", "Per-session, no contracts", "Average resolution: 35 min"],
    price: 59,
    priceLabel: "$59 / session",
  },
  {
    key: "antivirus-setup",
    icon: "ShieldHalf",
    title: "Antivirus Installation, Consultation & Removal",
    short: "Honest advice on the right antivirus for you — plus clean install, configuration and safe removal of unwanted security software.",
    bullets: [
      "Vendor-neutral recommendation",
      "Licensed install & tuning",
      "Safe uninstall of bloatware AV",
    ],
    price: 69,
    priceLabel: "$69 flat",
  },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Describe the issue", text: "Tell us what's wrong via the form, phone or remote session. Free over-the-phone advice first." },
  { n: "02", title: "Written diagnostic", text: "We run a full diagnostic and email you a written quote with parts, labour and timing." },
  { n: "03", title: "You approve, we fix", text: "Work only starts after you approve the quote. Live status updates throughout the repair." },
  { n: "04", title: "30-day guarantee", text: "Every repair is covered by our 30-day workmanship guarantee. No-fix-no-fee policy." },
];

export const TESTIMONIALS = [
  { name: "Sarah K.", role: "Graphic Designer · MacBook Pro", text: "My Mac was stuck in a boot loop the morning of a client deadline. Repair Point had me back online by lunch — clear pricing and zero upsell pressure." },
  { name: "Daniel R.", role: "Small Business Owner · Windows 11", text: "They removed a nasty ransomware infection and locked the network down properly. The written diagnostic made it easy to claim on insurance." },
  { name: "Priya M.", role: "Student · Lenovo ThinkPad", text: "My laptop took 6 minutes to boot. After the tune-up it's under 20 seconds. Honest, fast and friendly service." },
];

export const FAQS = [
  { q: "Are you affiliated with Microsoft or Apple?", a: "No. Repair Point is an independent third-party computer repair service. We are not affiliated with, endorsed by, or sponsored by Microsoft, Apple, or any other brand referenced on this site. All trademarks remain the property of their respective owners." },
  { q: "Do you offer a no-fix-no-fee guarantee?", a: "Yes. If we cannot resolve the issue you booked us for, you do not pay our labour fee. Diagnostic fees are refundable if you proceed with the repair." },
  { q: "How is my data handled during a repair?", a: "Your data stays on your device. Technicians only access files when strictly required to complete the repair and never copy personal data off your machine. See our Privacy Policy for full details." },
  { q: "What does the diagnostic fee cover?", a: "The $49 diagnostic covers a full hardware and software inspection and a written report with a fixed-price quote. It is waived if you proceed with a repair on the same day." },
  { q: "Do you accept refunds?", a: "Yes. We offer a 30-day workmanship warranty on labour and refunds on unused service fees. Please see our Refund Policy page for the full terms." },
  { q: "Can you fix older or out-of-warranty devices?", a: "Absolutely. We service Windows PCs from Windows 7 onwards and Macs from 2012 onwards, including out-of-warranty machines." },
  { q: "Will you ever cold-call me about my computer?", a: "No. Legitimate repair shops, including ours, will never cold-call you claiming your computer is infected. If you receive such a call, hang up and contact us directly via the number listed on this site." },
];

export const TRUST_BADGES = [
  "Windows PC Experts",
  "macOS Specialists",
  "10+ Years Experience",
  "No Fix, No Fee",
  "30-Day Workmanship Warranty",
  "Transparent Flat-Rate Pricing",
  "12,000+ Devices Serviced",
];

export const CERTIFICATIONS = [
  {
    key: "gdpr",
    label: "GDPR Compliant",
    body: "Data Privacy",
    detail: "Customer data handled in line with the EU General Data Protection Regulation. Minimal collection, lawful basis, right to erasure honoured within 30 days.",
    badge: "GDPR",
    color: "#0F4C81",
  },
  {
    key: "iso-9001",
    label: "ISO 9001:2015",
    body: "Quality Management",
    detail: "Documented quality management process for diagnostics, repairs and customer communication. Continuous improvement audited against ISO 9001:2015.",
    badge: "ISO 9001",
    color: "#0F4C81",
  },
  {
    key: "iso-27001",
    label: "ISO/IEC 27001:2022",
    body: "Information Security",
    detail: "Information security controls aligned with ISO/IEC 27001:2022 — encrypted workshop network, technician access logs and secure data handling end-to-end.",
    badge: "ISO 27001",
    color: "#0F4C81",
  },
];
